import {LitElement, html} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('step-three')
export class StepThree extends LitElement {

  @property({ type: Function }) onPrev!: () => void;

  render() {
    return html`
      <h2>Schritt 3</h2>
      <p>Vielen Dank! Ihr Prozess ist abgeschlossen.</p>
      <div class="controls">
        <button @click=${this.onPrev}>Zurück</button>
      </div>
    `;
  }
}
